import {PB_SUPPORTED_FEATURES} from "@shared/platform/enums/supportedFeatures"

export const PB_FEATURES = [PB_SUPPORTED_FEATURES.MERCHANDISE, PB_SUPPORTED_FEATURES.GROUP_CELEBRATION].join(",")
